import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const OrderHeader = ({ title = "Order Status" ,}) => {
    const handleBack=()=>{
 window.location.href = "/help&support"
  }

  return (
    <Box
      sx={{
        height: 64,
        bgcolor: "#f2d74c", // yellow
        display: "flex",
        alignItems: "center",
        px: 1.5,
        boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
        position: "sticky",
        top: 0,
        zIndex: 1000,
      }}
    >
      {/* Back Button */}
      <IconButton
        onClick={() => handleBack()}
        sx={{
          color: "#333",
          mr: 1,
        }}
      >
        <ArrowBackIcon />
      </IconButton>

      {/* Title */}
      <Typography
        fontWeight={700}
        fontSize={20}
        color="#333"
      >
        {title}
      </Typography>
    </Box>
  );
};

export default OrderHeader;
